import { cloneDeep } from "lodash";
import moment from "moment";
import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";

export const getAllContraindications = (callback, showLoading = true) => {
  return (dispatch) => {
    if (showLoading) dispatch(setLoading(true));
    return request("Contraindications", "get", null, true, null)
      .then((res) => {
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        if (showLoading) dispatch(setLoading(false));
      });
  };
};

export const getContraindicationById = (id, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Contraindications/${id}`, "get", null, true)
      .then((res) => {
        return { status: "success", data: res.data };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const createContraindication = (values, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Contraindications`, "post", values, true)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Contraindication created successfully"
        );
        return { status: "success", data: res?.data };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const deleteContraindication = (id, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Contraindications/${id}/Status?contraindicationId=${id}`,
      "patch",
      null,
      true
    )
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Contraindication inactivated successfully"
        );
        callback?.();
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const restoreContraindication = (id, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Contraindications/${id}/Status?contraindicationId=${id}`,
      "patch",
      null,
      true
    )
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Contraindication activated successfully"
        );
        callback?.();
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const updateContraindication = (id, data, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Contraindications/${id}`, "put", data, true)
      .then(() => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Contraindication updated successfully"
        );
        callback?.();
        return {
          status: "success",
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
